import React from 'react'
import connect from '../connect'
import { IconButton } from '@material-ui/core'
import MoreHorizIcon from '@material-ui/icons/MoreHoriz'
import {
  ContextMenuListItem,
  Popover,
} from '../../../components/common/Dialogs/Popover'
import useBooleanHandlers from '../../../hooks/useBooleanHandlers'
import usePopover from '../../../hooks/usePopover'
import ListItemTextBase from '../../../components/common/Containers/Base/ListItemTextBase'
import { useTrans } from '../../../services/i18n'
import ReplyModal from './ReplyModal'
import PdfViewerModal from './PdfViewerModal'
import AssignUserStaffModal from './AssignUserStaffModal'
import StatusManagementModal from './StatusManagementModal'
import { selectUserPermissions, isEnabled } from '../../../selectors'
import { useSelector } from 'react-redux'

const FormMenu = ({ form, users, fetchList, assignUser, downloadFormPdf, assignFormToStaff, updateFormAdminStatus }) => {
  const { trans } = useTrans()
  const permissions = useSelector(selectUserPermissions)

  const [anchorEl, onOpenPopover, onClosePopover] = usePopover()
  const [openReplyModal, onOpenReplyModal, onCloseReplyModal] =
    useBooleanHandlers()
  const [openAssignModal, onOpenAssignModal, onCloseAssignModal] =
    useBooleanHandlers()
  const [openPdfModal, onOpenPdfModal, onClosePdfModal] =
    useBooleanHandlers()
  const [openStatusModal, onOpenStatusModal, onCloseStatusModal] =
    useBooleanHandlers()

  return (
    <>
      <IconButton onClick={onOpenPopover}>
        <MoreHorizIcon />
      </IconButton>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={onClosePopover}
      >
        <ContextMenuListItem
          button
          onClick={onOpenReplyModal}
          onClickCB={onClosePopover}
        >
          <ListItemTextBase>{trans('reply')}</ListItemTextBase>
        </ContextMenuListItem>
        <ContextMenuListItem
          button
          onClick={onOpenPdfModal}
          onClickCB={onClosePopover}
        >
          <ListItemTextBase>{trans('see-response')}</ListItemTextBase>
        </ContextMenuListItem>
        {isEnabled(permissions, 'submitted-forms', '', 'edit') && (
          <>
            <ContextMenuListItem
              button
              onClick={onOpenAssignModal}
              onClickCB={onClosePopover}
            >
              <ListItemTextBase>{trans('assign-to')}</ListItemTextBase>
            </ContextMenuListItem>
            <ContextMenuListItem
              button
              onClick={onOpenStatusModal}
              onClickCB={onClosePopover}
            >
              <ListItemTextBase>{trans('status-management')}</ListItemTextBase>
            </ContextMenuListItem>
          </>
        )}
      </Popover>

      <ReplyModal
        open={openReplyModal}
        onClose={onCloseReplyModal}
        form={form}
        fetchList={fetchList}
      />

      <AssignUserStaffModal
        open={openAssignModal}
        onClose={onCloseAssignModal}
        form={form}
        assignFormToStaff={assignFormToStaff}
        fetchList={fetchList}
        users={users}
      />

      <PdfViewerModal
        open={openPdfModal}
        onClose={onClosePdfModal}
        form={form}
        downloadFormPdf={downloadFormPdf}
      />

      <StatusManagementModal
        open={openStatusModal}
        onClose={onCloseStatusModal}
        form={form}
        updateFormAdminStatus={updateFormAdminStatus}
        fetchList={fetchList}
      />
    </>
  )
}

export default connect(FormMenu)